import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { InfoTooltip } from '../../../../../InfoTooltip'
import { TooltipMetricExplanation } from '../../../../../TooltipMetricExplanation'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricHighlight,
} from '../../../BuildingCharacteristics.styles'
import type { ComparativeAnalysisCardProps } from '../NeighborhoodContextTab.types'

export const ComparativeAnalysisCard: React.FC<
  ComparativeAnalysisCardProps
> = ({
  buildingHeight,
  buildingArea,
  buildingVolume,
  neighborsHeightMean,
  neighborsAreaMean,
  neighborsVolumeMean,
  getComparisonText,
  t,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="bar-chart-2" size="small" />
          {t('neighborhood.cards.comparativeAnalysis.title')}
        </CardTitle>
      </CardHeader>
      <MetricGrid>
        {buildingHeight > 0 && neighborsHeightMean > 0 && (
          <MetricRow>
            <MetricLabel>
              {t('neighborhood.metrics.heightVsAverage.label')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t(
                    'neighborhood.metrics.heightVsAverage.tooltip.title'
                  )}
                  shortDescription={t(
                    'neighborhood.metrics.heightVsAverage.tooltip.description'
                  )}
                  calculation={t(
                    'neighborhood.metrics.heightVsAverage.tooltip.calculation'
                  )}
                  importance={t(
                    'neighborhood.metrics.heightVsAverage.tooltip.importance'
                  )}
                  source={t(
                    'neighborhood.metrics.heightVsAverage.tooltip.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricHighlight
              $type={
                buildingHeight > neighborsHeightMean * 1.2
                  ? 'info'
                  : buildingHeight < neighborsHeightMean * 0.8
                    ? 'warning'
                    : 'success'
              }
              $textAlign="right"
            >
              {getComparisonText(buildingHeight, neighborsHeightMean)}
            </MetricHighlight>
          </MetricRow>
        )}
        {buildingArea > 0 && neighborsAreaMean > 0 && (
          <MetricRow>
            <MetricLabel>
              {t('neighborhood.metrics.areaVsAverage.label')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t('neighborhood.metrics.areaVsAverage.tooltip.title')}
                  shortDescription={t(
                    'neighborhood.metrics.areaVsAverage.tooltip.description'
                  )}
                  calculation={t(
                    'neighborhood.metrics.areaVsAverage.tooltip.calculation'
                  )}
                  importance={t(
                    'neighborhood.metrics.areaVsAverage.tooltip.importance'
                  )}
                  source={t(
                    'neighborhood.metrics.areaVsAverage.tooltip.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricHighlight
              $type={
                buildingArea > neighborsAreaMean * 1.2
                  ? 'info'
                  : buildingArea < neighborsAreaMean * 0.8
                    ? 'warning'
                    : 'success'
              }
              $textAlign="right"
            >
              {getComparisonText(buildingArea, neighborsAreaMean)}
            </MetricHighlight>
          </MetricRow>
        )}
        {buildingVolume > 0 && neighborsVolumeMean > 0 && (
          <MetricRow>
            <MetricLabel>
              {t('neighborhood.metrics.volumeVsAverage.label')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t(
                    'neighborhood.metrics.volumeVsAverage.tooltip.title'
                  )}
                  shortDescription={t(
                    'neighborhood.metrics.volumeVsAverage.tooltip.description'
                  )}
                  calculation={t(
                    'neighborhood.metrics.volumeVsAverage.tooltip.calculation'
                  )}
                  importance={t(
                    'neighborhood.metrics.volumeVsAverage.tooltip.importance'
                  )}
                  source={t(
                    'neighborhood.metrics.volumeVsAverage.tooltip.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricHighlight
              $type={
                buildingVolume > neighborsVolumeMean * 1.2
                  ? 'info'
                  : buildingVolume < neighborsVolumeMean * 0.8
                    ? 'warning'
                    : 'success'
              }
              $textAlign="right"
            >
              {getComparisonText(buildingVolume, neighborsVolumeMean)}
            </MetricHighlight>
          </MetricRow>
        )}
      </MetricGrid>
    </Card>
  )
}
